import ConsumptionsPage from './ConsumptionsPage.vue';
import ConsumptionsEditPage from './ConsumptionsEditPage.vue';
import ConsumptionsTable from './ConsumptionsTable.vue';
import ConsumptionsSubPacksPage from './ConsumptionsSubPacksPage.vue';
import ConsumptionsRoutesPage from './ConsumptionsRoutesPage.vue';
import ConsumptionPerformancePage from './ConsumptionPerformancePage.vue';
import ConsumptionReasonPage from './ConsumptionReasonPage.vue';

export * from './types';
export {
    ConsumptionsPage as default,
    ConsumptionsPage,
    ConsumptionsEditPage,
    ConsumptionsTable,
    ConsumptionsSubPacksPage,
    ConsumptionsRoutesPage,
    ConsumptionPerformancePage,
    ConsumptionReasonPage
};
